// AUTO-GENERATED by generate-zod-schemas.ts — DO NOT EDIT
// Copyright 2026 Epic Digital Interactive Media LLC
// SPDX-License-Identifier: Apache-2.0

import { z } from 'zod'

export const appSnapshotSchema = z.object({
  id: z.string().max(100),
  orgId: z.string().max(100),
  workspaceId: z.string().max(100).optional(),
  userId: z.string().max(100).optional(),
  createdAt: z.string().max(200).datetime(),
  updatedAt: z.string().max(200).datetime(),
  metadata: z.record(z.string(), z.unknown()).optional(),
  extended: z.record(z.string(), z.unknown()).optional(),
  capturedBy: z.string().max(200),
  capturedAt: z.string().max(200).datetime(),
  appId: z.string().max(100),
  snapshotType: z.string().max(200),
  name: z.string().max(500),
  period: z.string().max(200),
  periodType: z.string().max(200),
  notes: z.string().max(5000).optional(),
  summary: z.record(z.string(), z.unknown()),
  data: z.record(z.string(), z.unknown()),
  tenantId: z.string().max(100).optional(),
})

export type AppSnapshotInput = z.infer<typeof appSnapshotSchema>
